import client from "../http-clients/api";
import type {
    IRegistryCreateRequest,
    IRegistryEditRequest,
    IRegistryListItem,
    IRegistryDetailsResponse,
    IRegistryRemoveSkuRequest,
    IUpdateSkuRegistriesRequest,
    IUpdateSkuAsMostWantedRequest,
    ICreditRegistryFundToWalletRequest,
    IPurchaseRemainingRegistryItemsRequest,
    IPurchaseRemainingRegistryItemsResponse,
    IContributeToRegistryRequest,
    IContributeToRegistryResponse,
} from "@types";
import gate from "../gate";

const registryApi = {
    create: (data: IRegistryCreateRequest) =>
        gate.post<number, IRegistryCreateRequest, never>({
            client,
            url: "user/registry",
            data,
        }),

    edit: (id: number, data: IRegistryEditRequest) =>
        gate.post<any, IRegistryEditRequest, never>({
            client,
            url: `user/registry/${id}/edit`,
            data,
        }),

    delete: (id: number) =>
        gate.post<any, never, never>({
            client,
            url: `user/registry/${id}/delete`,
        }),

    list: (skuId?: number, eventId?: number) =>
        gate.get<IRegistryListItem[], never, { skuId?: number; eventId?: number }>({
            client,
            url: "user/registry/list",
            params: {
                ...(skuId && { skuId: skuId }),
                ...(eventId && { eventId: eventId }),
            },
        }),

    getDetails: (id: string) =>
        gate.get<IRegistryDetailsResponse, never, never>({
            client,
            url: `user/registry/${id}`,
        }),

    removeSku: (registry_id: number,data: IRegistryRemoveSkuRequest) =>
        gate.post<any, IRegistryRemoveSkuRequest, never>({
            client,
            url: `user/registry/${registry_id}/removeSku`,
            data,
        }),

    updateSkuRegistries: (data: IUpdateSkuRegistriesRequest) =>
        gate.post<any, IUpdateSkuRegistriesRequest, never>({
            client,
            url: "user/registry/updateSkuRegistries",
            data,
        }),

    updateSkuAsMostWanted: (registry_id: number, data: IUpdateSkuAsMostWantedRequest) =>
        gate.post<any, IUpdateSkuAsMostWantedRequest, never>({
            client,
            url: `user/registry/${registry_id}/updateSkuAsMostWanted`,
            data,
        }),

    creditRegistryFundToWallet: (data: ICreditRegistryFundToWalletRequest) =>
        gate.post<any, ICreditRegistryFundToWalletRequest, never>({
            client,
            url: "user/registry/creditRegistryFundToWallet",
            data,
        }),

    purchaseRemainingItems: (data: IPurchaseRemainingRegistryItemsRequest) =>
        gate.post<IPurchaseRemainingRegistryItemsResponse, IPurchaseRemainingRegistryItemsRequest, never>({
            client,
            url: "user/registry/purchaseRemainingRegistryItems",
            data,
        }),

    contributeToRegistry: (id: number, data: IContributeToRegistryRequest) =>
        gate.post<IContributeToRegistryResponse, IContributeToRegistryRequest, never>({
            client,
            url: `user/registry/${id}/contributeToRegistry`,
            data,
        }),
};

export default registryApi; 